import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navigation-buttons',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class NavigationButtonsComponent {





  buttons = [
    { label: 'Pre-Trip Request', route: '/travelrequest/history', icon: 'assets/icons/PreripReq1.svg',type: 'svg' ,src:'assets/icons/countryinfo_icn.svg'},
    { label: 'ISOS Medical', route: 'https://myportal.internationalsos.com/', icon: 'assets/icons/isos.svg', type: 'svg', external: true },
    { label: 'Approvals', route: '/approvals', icon: 'assets/icons/Approvals1.svg', type: 'svg' },
    { label: 'Country Information', route: '/countryinformation', icon: 'assets/icons/CountryInfo1.svg', type: 'svg' },
    { label: 'Travel-Hub', route: 'https://slb001.sharepoint.com/sites/Travel', icon: 'assets/icons/Travel_Hub1.svg' , external : true}
  ];

  constructor(private router: Router) {}



handleClick(button: any): void {
  if (button.external) {
    window.open(button.route, '_blank');
  } else {
    this.navigateTo(button.route);
  }
}


  navigateTo(route: string): void {
    this.router.navigate([route]);
  }
}
